import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDTxHXgdBXjq1RPzpF4jxPy_ZFW0wVX2UE",
  authDomain: "dashawesome-1210.firebaseapp.com",
  databaseURL: "https://dashawesome-1210.firebaseio.com",
  projectId: "dashawesome-1210",
  storageBucket: "",
  messagingSenderId: "59899465481",
  appId: "1:59899465481:web:1d3162d3e8a807d8"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Setting for apply timestamps in firebase
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;
